module.exports = __webpack_public_path__ + "static/media/4-seo.944f594e.png";